module.exports = __webpack_public_path__ + "static/img/suimg1.39726851.png";